module.exports = "<span ng-message=\"required\">{{'errors.required' | i18n}}</span>\n<span ng-message=\"email\">{{'errors.email' | i18n}}</span>\n<span ng-message=\"match\">{{'errors.mailsmatch' | i18n}}</span>\n<div ng-message=\"minlength\">{{'errors.minlength' | i18n}}</div>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/app/errors/mailerrors.tpl.html
// module id = 927
// module chunks = 12